import { NavigateFunction } from "react-router";
import { useUserStore } from "./store";

export const loginUser = (
  email: string,
  password: string,
  navigate: NavigateFunction,
) => useUserStore.getState().loginUser(email, password, navigate);

export const logUserOut = (navigate: NavigateFunction) =>
  useUserStore.getState().logUserOut(navigate);

export const loadMyUser = (navigate: NavigateFunction) =>
  useUserStore.getState().loadMyUser(navigate);

export const myUserRefreshData = () =>
  useUserStore.getState().myUserRefreshData();
